var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getBreakpointSync } from '../lib-breakpointListener';
import { BREAKPOINTS_FROM } from '../lib-breakpoints';
import { resizeListener } from '../lib-resizeListener';
import { isSsr } from '../lib-ssr';
import { componentApi } from '../component-api-lib';
import * as React from 'react';
var Fullscreen = /** @class */ (function (_super) {
    __extends(Fullscreen, _super);
    function Fullscreen(props) {
        var _this = _super.call(this, props) || this;
        _this.emit = componentApi.emit.bind(_this);
        _this.writeState = componentApi.writeState.bind(_this);
        _this.fullscreenRef = React.createRef();
        _this.cgThrottle = componentApi.cgThrottle.bind(_this);
        _this.toCancel = [];
        _this.removeResizeObserver = function () { };
        _this.mutationObserver = { disconnect: function () { } };
        _this.isScrolledToTop = true;
        _this.handleChildElementBodyScroll = _this.cgThrottle(function (_a) {
            var target = _a.target;
            _this.isScrolledToTop = target.scrollTop === 0;
            if (_this.isMobile()) {
                if (!_this.state._isMobileScrolled && !_this.isScrolledToTop) {
                    _this.writeState('_isMobileScrolled', true);
                }
                else if (_this.isScrolledToTop) {
                    _this.writeState('_isMobileScrolled', false);
                }
            }
        });
        _this.previousSpaceSize = 0;
        _this.handleResize = _this.cgThrottle(function () {
            if (_this.isMobile()) {
                if (!_this.state._isMobileScrolled && !_this.isScrolledToTop) {
                    _this.writeState('_isMobileScrolled', true);
                }
                if (!_this.hasDefaultMode()) {
                    _this.writeState('_isMobileFullscreen', true);
                    return;
                }
                var _a = _this.getResizeInfo(), isExpanding = _a.isExpanding, skipResize = _a.skipResize;
                // sometimes we get same value even if window size has been changed
                if (skipResize) {
                    return;
                }
                // we rely on isExpanding to prevent opening-closing loop when resizing
                if (!_this.state._isMobileFullscreen &&
                    _this.isBodyOverflowed() &&
                    (!isExpanding || _this.previousSpaceSize === 0)) {
                    _this.writeState('_isMobileFullscreen', true);
                    _this.handleChildElementBodyScroll({ target: _this.childElementBody() }); // desktop scrolled body -> mobile scrolled
                }
                else if (_this.state._isMobileFullscreen &&
                    !_this.isBodyOverflowed() &&
                    isExpanding) {
                    _this.resetMobileStates();
                }
            }
            else {
                // reset mobile states when leaving the mobile view
                _this.resetMobileStates();
            }
            _this.previousSpaceSize =
                document.documentElement.clientHeight *
                    document.documentElement.clientWidth;
        });
        _this.handleMutation = _this.cgThrottle(function () {
            if (_this.isMobile()) {
                if (!_this.state._isMobileFullscreen && _this.isBodyOverflowed()) {
                    _this.writeState('_isMobileFullscreen', true);
                    return;
                }
            }
        });
        _this.onToggleFullscreen = function () {
            if (!_this.state._isFullscreen) {
                _this.openFullscreen();
            }
            else {
                _this.closeFullscreen();
            }
        };
        _this.closeFullscreen = function () {
            if (_this.state._isFullscreenInstant) {
                _this.setDefaultSize();
                _this.writeState('_isFullscreen', false);
                _this.writeState('_isFullscreenInstant', false);
            }
            else if (_this.state._isFullscreen) {
                var _a = _this.getWindowSize(), _b = _a.width, currentWidth = _b === void 0 ? 0 : _b, _c = _a.height, currentHeight = _c === void 0 ? 0 : _c;
                var _d = _this.state.windowSize, _e = _d.width, width = _e === void 0 ? 0 : _e, _f = _d.height, height = _f === void 0 ? 0 : _f;
                if (currentWidth !== width || currentHeight !== height) {
                    // window resize - skip animation to old place
                    _this.restoreMainElementPosition();
                }
                _this.writeState('_isFullscreen', false);
            }
        };
        _this.fullscreenOpenEnd = 'onFullscreenOpenEnd';
        _this.fullscreenCloseEnd = 'onFullscreenCloseEnd';
        _this.state = {};
        _this.state['_isMobileScrolled'] = null;
        _this.state['_isMobileFullscreen'] = null;
        _this.state['_fullscreenOpenEnd'] = _this.props.isFullscreen;
        _this.state['defaultSize'] = {
            width: null,
            height: null,
            top: null,
            left: null,
        };
        _this.state['_isFullscreen'] = _this.props.isFullscreen;
        _this.state['_isFullscreenInstant'] = false;
        _this.state['windowSize'] = null;
        _this.state['mainElementPosition'] = null;
        _this.onAnimationEnd = _this.onAnimationEnd.bind(_this);
        return _this;
    }
    Fullscreen.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { ref: this.fullscreenRef, "data-e2e": this.props.dataE2e, onAnimationEnd: function (event) { return _this.onAnimationEnd(event); }, className: 'cg-fullscreen ' +
                (this.state._isFullscreenInstant ? 'cg-fullscreen-instant ' : '') +
                (this.state._isFullscreen ? 'cg-fade-in ' : '') +
                (!this.state._isFullscreen && this.state._fullscreenOpenEnd
                    ? 'cg-fade-out '
                    : '') +
                (this.state._isMobileFullscreen ? 'cg-fullscreen-mobile-open ' : '') +
                (this.state._isMobileScrolled
                    ? 'cg-fullscreen-mobile-scrolled '
                    : '') +
                (this.state._fullscreenOpenEnd ? 'cg-fullscreen-open-end ' : '') }, this.props.children));
    };
    Fullscreen.prototype.hasDefaultMode = function () {
        return this.props.mobileMode === 'default';
    };
    Fullscreen.prototype.childElementBody = function () {
        var _a;
        return (_a = this.fullscreen()) === null || _a === void 0 ? void 0 : _a.querySelector(this.props.childBodySelector);
    };
    Fullscreen.prototype.fullscreen = function () {
        return this.fullscreenRef ? this.fullscreenRef.current : null;
    };
    Fullscreen.prototype.updateStyles = function () {
        this.fullscreen().style.width = this.state.defaultSize.width;
        this.fullscreen().style.height = this.state._isMobileFullscreen
            ? null
            : this.state.defaultSize.height;
        this.fullscreen().style.position = this.state.mainElementPosition;
        this.fullscreen().style.top = this.state.defaultSize.top;
        this.fullscreen().style.left = this.state.defaultSize.left;
    };
    Fullscreen.prototype.cg_change = function (prevProps) {
        if (prevProps.isFullscreen === false && this.props.isFullscreen === true) {
            this.openFullscreen();
        }
        else if (prevProps.isFullscreen === true &&
            this.props.isFullscreen === false) {
            this.closeFullscreen();
        }
        else if (prevProps.mainElementPosition === null && this.isFixed()) {
            this.writeState('_isFullscreen', true);
        }
        else if (prevProps._isFullscreenInstant === false &&
            this.state._isFullscreenInstant === true) {
            // Prepare for closing animation when the instant fullscreen was applied
            this.writeState('_isFullscreen', true);
        }
        if (this.isStateChanged('defaultSize', prevProps) ||
            this.isStateChanged('_isMobileFullscreen', prevProps) ||
            this.isStateChanged('mainElementPosition', prevProps)) {
            this.updateStyles();
        }
    };
    Fullscreen.prototype.applyMobileBehavior = function () {
        var _a;
        if (this.hasDefaultMode()) {
            this.mutationObserver = new MutationObserver(this.handleMutation);
            this.mutationObserver.observe(this.childElementBody(), {
                childList: true,
                subtree: true,
                attributes: true,
                characterData: true,
            });
        }
        this.removeResizeObserver = resizeListener(this.fullscreen(), this.handleResize);
        this.handleChildElementBodyScroll({ target: this.childElementBody() });
        (_a = this.childElementBody()) === null || _a === void 0 ? void 0 : _a.addEventListener('scroll', this.handleChildElementBodyScroll);
    };
    Fullscreen.prototype.clearMobileBehavior = function () {
        if (!isSsr) {
            this.previousSpaceSize = 0;
            this.resetMobileStates();
            this.removeResizeObserver();
            this.hasDefaultMode() && this.mutationObserver.disconnect();
        }
    };
    Fullscreen.prototype.getBodyDimensions = function () {
        var _a = this.childElementBody(), scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight, clientWidth = _a.clientWidth;
        return { scrollHeight: scrollHeight, clientHeight: clientHeight, clientWidth: clientWidth };
    };
    Fullscreen.prototype.isBodyOverflowed = function () {
        var _a = this.getBodyDimensions(), scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
        return scrollHeight > clientHeight;
    };
    Fullscreen.prototype.isMobile = function () {
        var breakpoint = getBreakpointSync();
        return (BREAKPOINTS_FROM[breakpoint] <=
            BREAKPOINTS_FROM[this.props.fullscreenBreakpoint]);
    };
    Fullscreen.prototype.getResizeInfo = function () {
        var clientHeight = document.documentElement.clientHeight;
        var clientWidth = document.documentElement.clientWidth;
        var currentSpaceSize = clientHeight * clientWidth;
        if (this.previousSpaceSize > currentSpaceSize) {
            return { isExpanding: false };
        }
        else if (this.previousSpaceSize === currentSpaceSize) {
            return { isExpanding: null, skipResize: true };
        }
        return { isExpanding: true };
    };
    Fullscreen.prototype.resetMobileStates = function () {
        if (this.state._isMobileFullscreen) {
            this.writeState('_isMobileFullscreen', false);
        }
        if (this.state._isMobileScrolled) {
            this.writeState('_isMobileScrolled', false);
        }
    };
    Fullscreen.prototype.setDefaultSize = function () {
        this.writeState('defaultSize', {
            width: this.props.maxWidth,
            height: this.props.maxHeight,
            top: null,
            left: null,
        });
    };
    Fullscreen.prototype.getWindowSize = function () {
        var width = window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth;
        var height = window.innerHeight ||
            document.documentElement.clientHeight ||
            document.body.clientHeight;
        return { width: width, height: height };
    };
    Fullscreen.prototype.openFullscreen = function () {
        this.writeState('windowSize', this.getWindowSize());
        var fullscreen = this.fullscreen();
        var _a = fullscreen.getBoundingClientRect(), height = _a.height, top = _a.top, left = _a.left;
        this.writeState('defaultSize', __assign(__assign({}, this.state.defaultSize), { height: this.props.maxHeight || this.toPx(height), top: this.toPx(top), left: this.toPx(left) }));
        this.writeState('mainElementPosition', 'fixed');
    };
    Fullscreen.prototype.restoreMainElementPosition = function () {
        this.writeState('mainElementPosition', null);
    };
    Fullscreen.prototype.toPx = function (val) {
        return val + 'px';
    };
    Fullscreen.prototype.isFixed = function () {
        return this.state.mainElementPosition === 'fixed';
    };
    Fullscreen.prototype.onAnimationEnd = function (e) {
        if (e.target !== this.fullscreenRef.current) {
            return;
        }
        if (this.isFixed()) {
            if (this.state._isFullscreen) {
                this.onFullscreenOpened();
            }
            else {
                this.restoreMainElementPosition();
                this.onFullscreenClosed();
            }
        }
        else if (!this.state._isFullscreenInstant) {
            this.onFullscreenClosed();
        }
    };
    Fullscreen.prototype.onFullscreenOpened = function () {
        this.writeState('_fullscreenOpenEnd', true);
        this.emit(this.fullscreenOpenEnd);
    };
    Fullscreen.prototype.onFullscreenClosed = function () {
        this.setDefaultSize();
        this.writeState('_fullscreenOpenEnd', false);
        this.emit(this.fullscreenCloseEnd);
    };
    Fullscreen.prototype.isPropChanged = function (propName, prevProps) {
        return (propName in prevProps && prevProps[propName] !== this.props[propName]);
    };
    Fullscreen.prototype.isStateChanged = function (propName, prevProps) {
        return (propName in prevProps && prevProps[propName] !== this.state[propName]);
    };
    Fullscreen.prototype.componentDidMount = function () {
        this.fullscreen().addEventListener('cgToggleFullscreen', this.onToggleFullscreen);
        if (!this.props.isFullscreen) {
            this.setDefaultSize();
        }
        else {
            this.writeState('_isFullscreenInstant', true);
        }
        !isSsr && this.childElementBody() && this.applyMobileBehavior();
        this.updateStyles();
    };
    Fullscreen.prototype.componentWillUnmount = function () {
        this.clearMobileBehavior();
        this.fullscreen().removeEventListener('cgToggleFullscreen', this.onToggleFullscreen);
        this.toCancel.forEach(function (cancelableFunc) {
            cancelableFunc();
        });
    };
    Fullscreen.prototype.componentDidUpdate = function (prevProps, prevState) {
        this.cg_change(__assign(__assign({}, prevProps), prevState));
    };
    Fullscreen.defaultProps = {
        dataE2e: 'cg-fullscreen',
        mobileMode: 'default',
        isFullscreen: false,
        fullscreenBreakpoint: 'XS',
        childBodySelector: 'modal-body-tabbed, [data-e2e="cg-modal-body"], [data-e2e="cg-modal-body-tabbed"]',
    };
    Fullscreen.displayName = 'Fullscreen';
    return Fullscreen;
}(React.Component));
export { Fullscreen };
